import { Module } from '../Module';
import { IFilterControl } from './FilterPanelCtrl';

export interface IDateFilterScope extends ng.IScope {
  filter: IFilterControl;

  editMode: boolean;
  clear: () => void;
  open:  () => void;
  close: () => void;
}

export class DateFilterCtrl {

  public static $inject = ['$scope'];

  constructor($scope: IDateFilterScope) {

    $scope.editMode = false;

    $scope.clear = () => {
      $scope.filter.value = null;
    };

    $scope.open = () => {
      $scope.editMode = true;
    };

    $scope.close = () => {
      $scope.editMode = false;
    };

  }

}

Module.instance().controller('DateFilterCtrl', DateFilterCtrl);
